module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_01.ea834054.gif";